import { render, staticRenderFns } from "./textdetails.vue?vue&type=template&id=50cd98de&scoped=true&"
import script from "./textdetails.vue?vue&type=script&lang=js&"
export * from "./textdetails.vue?vue&type=script&lang=js&"
import style0 from "./textdetails.vue?vue&type=style&index=0&id=50cd98de&scoped=scoped&lang=scss&"
import style1 from "./textdetails.vue?vue&type=style&index=1&id=50cd98de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cd98de",
  null
  
)

export default component.exports